var FixedNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-fixed-nav]',
		navMenu: '[data-fixed-nav-menu]',
	}

	FixedNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new FixedNav(el);
		});
	}

	class FixedNav {
		constructor(element) {
			this.$wrap = $(element);
			this.$nav = $(selectors.navMenu, this.$wrap);

			this.init();
			this.resize();
			this.bind();

		}
		init() {

			this.links = $('a[href^="#"]:not([href="#"])', this.$nav);
			this.targets = [];
			this.menuOffsetTop = this.$wrap.offset().top;
			this.is_sticky = false;
			this.links.each((i, link) => {
				var $target = $($(link).attr('href'));
				if ($target.length) {
					var targetData = {
						el: $target.get(0),
						link: link,
						offset: $target.offset().top - 5
					};

					if ($(targetData.link).attr('data-offset') !== undefined) {
						targetData.offset -= parseFloat($(targetData.link).attr('data-offset'));
					}
					else if (window.headerHeight && $(targetData.link).attr('data-ignore-header') === undefined) {
						targetData.offset -= window.headerHeight;
					}

					this.targets.push(targetData);
				}
			});

		}
		resize() {

			this.menuOffsetTop = this.$wrap.offset().top;

			$(this.targets).each((i, targetData) => {

				targetData.offset = $(targetData.el).offset().top - 5;

				if ($(targetData.link).attr('data-offset') !== undefined) {
					targetData.offset -= parseFloat($(targetData.link).attr('data-offset'));
				}
				else if (window.headerHeight && $(targetData.link).attr('data-ignore-header') === undefined) {
					targetData.offset -= window.headerHeight;
				}
			});

			this.targets.sort((a, b) => (a.offset > b.offset) ? 1 : ((b.offset > a.offset) ? -1 : 0));

			this.scroll();

		}
		bind() {

			$(document).ready((e) => { this.resize(); });
			$(window).resize((e) => { this.resize(); });

			$(window).scroll((e) => { this.scroll(); });

			$(window).on('smooth-scroll-started', (e) => { this.isScrolling = true; });
			$(window).on('smooth-scroll-ended', (e) => { this.isScrolling = false; });
			$(window).on('smooth-scroll-ended', (e) => { this.scroll(); });

			$(this.links).click((e) => { this.linkClicked($(e.target).closest('a').get(0)); })
		}

		scroll() {

			const scrollOff = $(window).scrollTop() + $('#site-header').outerHeight();

			if (scrollOff >= this.menuOffsetTop && !this.is_sticky) {
				this.stick();
			}
			else if (scrollOff < this.menuOffsetTop && this.is_sticky) {
				this.unstick();
			}

			this.setActive();

		}


		linkClicked(link) {

			if (!$($(link).attr('href')).length) return;

			$(this.links).removeClass('is-active');
			$(link).addClass('is-active');
		}

		stick() {
			this.is_sticky = true;
			this.$wrap.css('height', this.$wrap.outerHeight());
			this.$nav.addClass('is-sticky');
			$(document.body).addClass('has-sticky-nav');
		}

		unstick() {
			this.is_sticky = false;
			this.$wrap.css('height', '');
			this.$nav.removeClass('is-sticky');
			$(document.body).removeClass('has-sticky-nav');
		}

		setActive() {

			if (this.isScrolling) return;

			const self = this;
			const scrollOff = $(window).scrollTop() + $('#site-header').outerHeight();
			var has_active = false;

			$(this.targets).each((i, targetData) => {

				var is_active = scrollOff >= targetData.offset;

				if (i < self.targets.length - 1 && scrollOff >= self.targets[i + 1].offset) {
					// console.log('next active');
					is_active = false;
				}

				if (is_active) {
					$(targetData.link).addClass('is-active');
					has_active = true;
				}
				else {
					$(targetData.link).removeClass('is-active');
				}

			});

			if (!has_active && this.targets.length) {
				$(this.targets[0].link).addClass('is-active');
			}

		}

	}

})(jQuery);


export default FixedNavInit;